import { useState } from 'react'
import { isApiError } from '../../api/client'
import { EmptyState, Spinner } from '../../design'
import { canManageSettings } from '../../session/roles'
import { useReadySession } from '../../session/useSession'
import { OPERATIONS_COPY } from './copy'
import { DeadLetterList } from './DeadLetterList'
import { ProviderPanel } from './ProviderPanel'
import { useDeadLetters, useProviderOverview, useReplayDeadLetter, useSlaOverview } from './queries'
import { SlaPanel } from './SlaPanel'

export const OperationsPage = () => {
  const { membership } = useReadySession()
  const allowed = canManageSettings(membership.role)
  const sla = useSlaOverview()
  const providers = useProviderOverview()
  const deadLetters = useDeadLetters()
  const replay = useReplayDeadLetter()
  const [pendingId, setPendingId] = useState<string | null>(null)

  if (!allowed) {
    return <EmptyState title={OPERATIONS_COPY.forbidden} description={OPERATIONS_COPY.forbiddenBody} />
  }

  if (sla.isPending || deadLetters.isPending || providers.isPending) return <Spinner label={OPERATIONS_COPY.slaLoading} />

  const error = [sla.error, providers.error, deadLetters.error, replay.error].find(isApiError)?.message ?? null

  const onReplay = (jobId: string) => {
    setPendingId(jobId)
    replay.mutate(jobId, { onSettled: () => setPendingId(null) })
  }

  return (
    <section className="operations">
      <h1>{OPERATIONS_COPY.title}</h1>
      {error === null ? null : (
        <p className="operations-error tone-danger" role="alert">
          {error}
        </p>
      )}
      {providers.data === undefined ? null : <ProviderPanel overview={providers.data} />}
      {sla.data === undefined ? null : <SlaPanel overview={sla.data} />}
      {deadLetters.data === undefined ? null : (
        <DeadLetterList
          jobs={deadLetters.data.jobs}
          total={deadLetters.data.total}
          pendingId={pendingId}
          onReplay={onReplay}
        />
      )}
    </section>
  )
}
